module.exports = __webpack_public_path__ + "static/img/video-7.26df4df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-7.jpg
// module id = jiJr
// module chunks = 12